export const GET_SHIPMENT_BY_ID = 'GET_SHIPMENT_BY_ID'
export const GET_SHIPMENT_BY_ID_SUCCESS = 'GET_SHIPMENT_BY_ID_SUCCESS'
export const GET_SHIPMENT_BY_ID_FAILS = 'GET_SHIPMENT_BY_ID_FAILS'
export const TO_TRANSMITED_SHIPMENT_FAILS = 'TO_TRANSMITED_SHIPMENT_FAILS'
export const GET_LIST_CHANNEL_SHIPMENT = 'GET_LIST_CHANNEL_SHIPMENT'
export const GET_LIST_CHANNEL_SHIPMENT_SUCCESS = 'GET_LIST_CHANNEL_SHIPMENT_SUCCESS'
export const TOGGLE_DATA_EXPORT_VISIBILITY = 'TOGGLE_DATA_EXPORT_VISIBILITY'
export const ON_CLEAR_FEED = 'ON_CLEAR_FEED'
export const CLEAR_FEED_SUCCESS = 'CLEAR_FEED_SUCCESS'
export const CLEAR_FEED_FAILURE = 'CLEAR_FEED_FAILURE'

export const setFulfillmentOption = payload => ({
    type: 'SET_FULFILLMENT_OPTION',
    payload
})

export const resetSumaryShipment = payload => ({
    type: 'RESET_SUMARY_SHIPMENT',
})

export const onLoadShipment = payload => ({
    type: 'ON_LOAD_SHIPMENT',
    payload,
})
export const addFilterShipment = () => ({
    type: 'ADD_FILTER_SHIPMENT',
})

export const onChange = payload => ({
    type: 'ON_CHANGE_FILTER_SHIPMENT',
    payload,
})
export const onSubmit = payload => ({
    type: 'ON_SUBMIT_SHIPMENT',
    payload,
})
export const onCloseFilter = payload => ({
    type: 'CLOSE_FILTER_SHIPMENT',
    payload,
})
export const onReset = (payload) => ({
    type: 'ON_RESET_SHIPMENT_FILTER',
    payload
})

export const onSort = payload => ({
    type: 'ON_SORT_SHIPMENT',
    payload,
})

export const onCheck = payload => ({
    type: 'ON_CHECK_SHIPMENT',
    payload,
})
export const onCheckAll = payload => ({
    type: 'ON_CHECK_ALL_SHIPMENT',
    payload,
})

export const onSortOrdersSuccess = payload => ({
    type: 'ON_SORT_SHIPMENT_SUCCESS',
    payload,
})

export const onSortOrdersFailure = payload => ({
    type: 'ON_SORT_SHIPMENT_FAILURE',
    payload,
})
export const getShipmentsByPage = payload => ({
    type: 'ON_GET_SHIPMENT_BY_PAGE',
    payload,
})

export const onChangeOffset = payload => ({
    type: 'ON_CHANGE_OFFSET_SHIPMENT_LIST',
    payload,
})
export const nextOrBack = payload => ({
    type: 'ON_NEXT_OR_BACK_SHIPMENT',
    payload,
})
export const onRemoveFilter = payload => ({
    type: 'ON_REMOVE_FILTER_SHIPMENT',
    payload,
})
export const onTab = payload => ({
    type: 'ON_TAB_SHIPMENT',
    payload,
})

export const deleteShipment = (payload) => ({
    type: 'ON_DELETE_SHIPMENT',
    payload
})

export const deleteShipmentSuccess = (payload) => ({
    type: 'DELETE_SHIPMENT_SUCCESS',
    payload
})

export const deleteShipmentFailure = (payload) => ({
    type: 'DELETE_SHIPMENT_FAILURE',
    payload
})

export const clearShipmentFailFeed = (payload) => {

    console.log('clearShipmentFailFeed', payload);
    
    return {
        type: ON_CLEAR_FEED,
        payload
    }
}

export const clearFeedSuccess = (payload) => ({
    type: CLEAR_FEED_SUCCESS,
    payload
})

export const clearFeedFailure = (payload) => ({
    type: CLEAR_FEED_FAILURE,
    payload
})

export const addPackageInfo = (payload) => ({
    type: 'ON_ADD_PACKAGE_INFO',
    payload
})

export const onChangePackageInfo = (payload) => ({
    type: 'ON_CHANGE_ADD_PACKAGE_INFO',
    payload
})

export const submitPackageInfo = (payload) => ({
    type: 'ON_SUBMIT_PACKAGE_INFO',
    payload
})

export const onOk = (payload) => ({
    type: 'ON_OK',
    payload
})

export const update = (payload) => ({
    type: 'UPDATE',
    payload
})

export const toTransmited = (payload) => ({
    type: 'TO_TRANSMITED',
    payload
})
export const toTransmitedShipmentSuccess = (payload) => ({
    type: 'TO_TRANSMITED_SHIPMENT_SUCCESS',
    payload
})
export const toTransmitedShipmentFails = (payload) => ({
    type: TO_TRANSMITED_SHIPMENT_FAILS,
    payload
})
export const toTransmitedShipmentFailure = (payload) => ({
    type: 'TO_TRANSMITED_SHIPMENT_FAILURE',
    payload
})
export const getLabelInfo = (payload) => ({
    type: 'GET_LABEL_INFO',
    payload
})
export const getLabelInfoSuccess = (payload) => ({
    type: 'GET_LABEL_INFO_SUCCESS',
    payload
})
export const getLabelInfoFailure = (payload) => ({
    type: 'GET_LABEL_INFO_FAILURE',
    payload
})

export const getShipmentById = (payload) => {
    return {
        type: GET_SHIPMENT_BY_ID,
        payload
    }
}

export const getShipmentByIdSuccess = (payload) => {
    return {
        type: GET_SHIPMENT_BY_ID_SUCCESS,
        payload
    }
}

export const getShipmentByIdFails = (payload) => {
    return {
        type: GET_SHIPMENT_BY_ID_FAILS,
        payload
    }
}

export const getPackageInfoById = (payload) => {
    return {
        type: 'GET_PACKAGE_INFO_BY_ID',
        payload
    }
}
export const getPackageInfoByIdSuccess = (payload) => {
    return {
        type: 'GET_PACKAGE_INFO_SUCCESS',
        payload
    }
}
export const getPackageInfoByIdFailure = (payload) => {
    return {
        type: 'GET_PACKAGE_INFO_FAILURE',
        payload
    }
}

export const getPackageInfoByShipmentId = (payload) => {
    return {
        type: 'GET_PACKAGE_INFO_BY_SHIPMENT_ID',
        payload
    }
}

export const getPackageInfoByShipmentIdSuccess = (payload) => {
    return {
        type: 'GET_PACKAGE_INFO_BY_SHIPMENT_ID_SUCCESS',
        payload
    }
}

export const getPackageInfoByShipmentIdFailure = (payload) => {
    return {
        type: 'GET_PACKAGE_INFO_BY_SHIPMENT_ID_FAILURE',
        payload
    }
}

export const getListChannelShipment = (payload) => {
    return {
        type: 'GET_LIST_CHANNEL_SHIPMENT',
        payload
    }
}
export const getListChannelShipmentSuccess = (payload) => {
    return {
        type: 'GET_LIST_CHANNEL_SHIPMENT_SUCCESS',
        payload
    }
}
export const toggleDataExportVisibility = (payload) => {
    return {
        type: TOGGLE_DATA_EXPORT_VISIBILITY,
        payload
    }
}



// WEBPACK FOOTER //
// ./src/actions/shipmentAction.js